import FasCheckCircle from 'components/Legacy/Icons/FasCheckCircle'
import Link from 'components/Link'
import { selectors } from 'data'
import Cookies from 'js-cookie'
import { LanguageType } from 'providers/ConnectedIntl/languages'
import React, { useCallback } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { localizeUrl } from 'services/urlService'
import styled from 'styled-components'
import { color, screenWidth, theme } from 'utils'

type OwnPropsType = {
  display: string
  prefix: LanguageType
}

type PropsType = ConnectedProps<typeof connector> & OwnPropsType

const Wrapper = styled.div`
  position: relative;
  flex: 1 0 auto;
  width: 100%;
  padding: 0.5rem 2rem;

  @media only screen and (min-width: ${screenWidth('sm')}) {
    width: 33%;
    padding: 2rem;
  }
`
const Icon = styled(FasCheckCircle)`
  position: absolute;
  left: 0.5rem;
  background: ${color('dark900')};
  border-radius: 50%;
  fill: ${theme('successColor')};

  &:hover {
    fill: ${theme('successColor')};
  }
`

const LanguageItem = ({ display, language, prefix, toggleLanguage }: PropsType) => {
  const onClick = useCallback(() => {
    toggleLanguage(prefix)
  }, [toggleLanguage, prefix])

  return (
    <Wrapper>
      {language === prefix && <Icon size='18px' />}
      <Link color='blue600' onClick={onClick}>
        {display}
      </Link>
    </Wrapper>
  )
}

const mapStateToProps = (state) => ({
  language: selectors.app.getLanguage(state)
})

const closeCallback = (locale) => {
  // Set Cookie
  Cookies.set('clang', locale, {
    expires: 365,
    path: '/'
  })
  // Redirect
  window.location.reload()
}

const mapDispatchToProps = () => ({
  toggleLanguage: (language: LanguageType) => {
    closeCallback(language)
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(LanguageItem)
